import * as types from "./clientActionTypes";

const initialState = {
  data: null,
  isMintEnabled: null,
};

export default function clientReducer(state = initialState, action) {
  const { type, payload } = action;

  switch (type) {
    case types.SET_LAST_GENERATED_MEMBER:
      return {
        ...state,
        data: payload,
      };
    case types.SET_MINT_ENABLED_STATUS:
      // Store MINT enabled status in Redux so child components can access it
      return {
        ...state,
        isMintEnabled: payload,
      };
    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/components/dashboard/clients/client/clientReducer.js